module.exports = __webpack_public_path__ + "media/5.5a5f1b4f.mp3";